import React, { Component } from "react";
import { withRouter } from "react-router";
import Header from "../../common/header";
import AccountBalanceIcon from "@material-ui/icons/AccountBalance";
import ScrollToTop from "../../common/scrollToTop";
import LoadingSpinnerNav from "../../common/loadingSpinnerNavbar";
import {
  getParishByCode,
  getParishes,
  getParishLinkById,
} from "../../../services/parish";
import { getBulletin } from "../service/bulletin";
import BulletinEntry from "../component/bulletinEntry";
import LinkButton from "../../blocks/linkButtonBlock";
import SharePage from "../../common/sharePage";
import { logEvent } from "../../../services/log";
import fire from "../../../services/fire";
import { getLikesByType } from "../../../services/like";
import { Link } from "react-router-dom";
import { genBrowserId } from "../../../utils/browserid";
import EventAvailableRoundedIcon from "@material-ui/icons/EventAvailableRounded";
import { getRandomArrayEntry } from "../../../utils/randomiser";
import "../assets/css/bulletin.css";
import ReloadModal from "../../common/reloadModal";

class ViewAllBulletin extends Component {
  constructor(props) {
    super(props);
    this.state = {
      bulletinlist: [],
      errors: {},
      user: this.props.user,
      loading: true,
      selected: "",
    };
  }

  getBulletin = async (parish) => {
    //retrieve data from firestore
    try {
      const bulletin = await getBulletin(parish.toString());
      this.setState({
        bulletinlist: bulletin,
      });
    } catch (error) {
      console.error("Bulletin not yet created");
      this.setState({ loading: false });
    }
  };

  async componentDidMount() {
    const parishCode = this.props.match.params.parishId;
    let parish = getParishByCode(parishCode);
    if (!parish) {
      //reroute
      const randomChurch = getRandomArrayEntry([
        "cathedral",
        // "holycross",
        // "christtheking",
        // "divinemercy",
        // "queenofpeace",
        // "stignatius",
        // "stvincentdepaul",
        // "ststephen",
        // "stfrancisxavier",
        // "stfrancisassisi",
        // "stanthony",
        // "stanne",
        // "holyspirit",
        // "holyfamily",
        // "blessedsacrament",
      ]);
      parish = getParishByCode(randomChurch);
      // console.log(`Setting to ${randomChurch}...`);
      this.props.history.replace(`/bulletin/${randomChurch}`);
    }

    await this.getBulletin(parish._id);
    //get likes here
    let likes = [];
    let browserid = genBrowserId();
    let uid = browserid;
    // console.log(browserid);
    if (this.props.user) {
      uid = this.props.user.uid;
    }

    likes = await getLikesByType(uid, "bulletin");
    logEvent(`load_bulletin_${parish.link}`, {
      type: "bulletin",
    });

    this.setState({
      likes,
      parish,
      userid: uid,
      browserid: browserid,
      loading: false,
      selected: parish._id,
      options: getParishes(),
    });
    window.scrollTo(0, 0);
  }

  handleChange = async ({ currentTarget: input }) => {
    const selection = input.value || 1;
    const parish = getParishLinkById(selection);
    this.props.history.replace(`/bulletin/${parish}`);
    await this.getBulletin(selection);

    this.setState({
      selected: selection,
      parish: getParishByCode(parish),
    });
    window.scrollTo(0, 0);
  };

  sendRequest = (parish) => {
    logEvent(`sent_request_${parish}`, {
      type: "bulletin",
    });
  };

  submitRequest = async (parish) => {
    logEvent(`bulletin_request_${parish.link}`, {
      type: "bulletin",
    });
    const objid = `bulletin_${parish.link}`;
    const user = this.props.user;
    const created = new Date();
    const timestamp = created.getTime();
    const db = fire.firestore();
    let fullname = "Guest";
    let email = "";
    let mobile = "";
    let smallpic = "";
    let userid = this.state.userid;
    if (user) {
      fullname = user.displayName;
      email = user.email;
      smallpic = user.photoURL || "";
      userid = user.uid;
      mobile = user.mobile;
    }
    const results = await db
      .collection("likes")
      .where("objid", "==", objid)
      .where("userid", "==", userid)
      .get();
    const result = [];
    results.forEach((doc) => {
      result.push(doc.data());
    });

    const likeObj = {
      fullname,
      email,
      mobile,
      smallpic,
      userid,
      parish: parish._id.toString(),
      parishcode: parish.link,
      header: "Request for Bulletin",
      objid: objid,
      objtype: "bulletin",
      created,
      timestamp,
    };
    if (result.length === 0) {
      const likeRef = db.collection(`likes`).doc();
      likeRef.set(likeObj);
    } else {
      console.log("Skipping update...");
    }
    //add to likes
    this.setState({ likes: [...this.state.likes, likeObj] });
  };

  render() {
    const { loading, bulletinlist, parish, options, likes } = this.state;

    if (loading === true) {
      return <LoadingSpinnerNav hide="profile" type="backandlogo" />;
    }
    const parishLink = `/parish/${parish.link}`;
    // const bulletinlink = window.location.href;
    // const parishemail = parish.email;
    // const parishname = parish.completename;
    const label = "Get More Church Info";
    const shareText = `⛪ ${parish.completename} Bulletin

`;

    const found = likes.filter((i) => i.parishcode === parish.link);
    return (
      <React.Fragment>
        {/* {this.props.user ? (
          <Header type="backandlogo" />
        ) : ( */}
        <Header type="backandlogo" />
        <ReloadModal />
        {/* )} */}
        {/* <ParishLogoBlock parishId={parish._id} /> */}
        <div className="row justify-content-center  mx-0">
          <div className="col-lg-6">
            <main className="container px-0 mx-auto">
              <div className="pb-4">
                <div id="bulletinsection" className="mb-4 pt-0">
                  <h3 className="text-left py-4 m-0">Church Bulletins</h3>
                  <div className="form-group pb-2">
                    <div className="float-left pt-1 pb-2">
                      <label htmlFor="parish">
                        <h4 className="text-danger">
                          Select Church{" "}
                          <AccountBalanceIcon className="ml-1 adjusticon" />
                        </h4>
                      </label>
                    </div>
                    <div className="float-right">
                      <SharePage
                        source="bulletin"
                        title={`⛪ ${parish.completename} Bulletin`}
                        text={shareText}
                        url={`/bulletin/${parish.link}`}
                      />
                    </div>
                    <div className="clearfix"></div>
                    <select
                      name="parish"
                      id="parish"
                      value={this.state.selected}
                      onChange={this.handleChange}
                      className="form-control form-control-lg custom-select custom-select-lg"
                    >
                      <option value="" />
                      {options.map((option) => (
                        <option key={option._id} value={option._id}>
                          {option.name}
                        </option>
                      ))}
                    </select>
                  </div>

                  {bulletinlist.length > 0 &&
                    bulletinlist.map((entry) => {
                      return (
                        <BulletinEntry
                          key={entry.id}
                          entry={entry}
                          extra={
                            <div className="text-left pb-2">
                              <EventAvailableRoundedIcon className="ml-3 text-primary" />
                              <Link
                                className="px-1 btn-link btn btn-md defaultfontsize"
                                to={`/schedules/${parish.link}`}
                              >
                                See Mass Schedules
                              </Link>
                            </div>
                          }
                        />
                      );
                    })}
                  {bulletinlist.length === 0 && (
                    <div className="p-4 largefontsize text-center">
                      {found.length === 0 && (
                        <>
                          <div>No bulletin?</div>
                          <div className="mt-4 defaultfontsize">
                            We are sorry about that{" "}
                            <span role="img" aria-label="heart">
                              ❤️
                            </span>
                          </div>
                          <div className="mt-4 defaultfontsize">
                            Let us know if you would love to see your church
                            bulletin here, and we'll work on it.
                          </div>
                          <div className="text-center my-4 py-4">
                            <button
                              className="btn-primary btn btn-md defaultfontsize"
                              onClick={() => this.submitRequest(parish)}
                            >
                              Yes, please
                            </button>
                            <p className="pt-2 biggerfontsize">
                              Click here{" "}
                              <span role="img" aria-label="index">
                                ☝️
                              </span>
                            </p>
                          </div>
                        </>
                      )}
                      {found.length !== 0 && (
                        <>
                          <div className="mt-4 defaultfontsize">
                            <span
                              role="img"
                              className="largefontsize"
                              aria-label="thankyou"
                            >
                              🙏
                            </span>
                            <br />
                            Thank you for your interest!
                          </div>
                          <div className="mt-4 defaultfontsize">
                            We will inform the church of your interest in the
                            Church Bulletin.
                          </div>
                          {parishLink && (
                            <div className="text-center mt-4 pt-4">
                              <Link
                                className="btn-link btn btn-md defaultfontsize"
                                to={parishLink}
                              >
                                {label}
                              </Link>
                            </div>
                          )}
                          <div className="text-center mb-4 pb-4">
                            <Link
                              className="btn-link btn btn-md defaultfontsize"
                              to={`/schedules/${parish.link}`}
                            >
                              See Mass Schedules
                            </Link>
                          </div>
                        </>
                      )}
                      {/* {parishLink && (
                        <div className="text-center my-4 py-4">
                          <a
                            className="btn-primary btn btn-md defaultfontsize"
                            href={`mailto:${parishemail}?subject=Request for Bulletin&body=Hi ${parishname},%0D%0A%0D%0AI love to have your bulletin posted here ${bulletinlink} so we can see all our church bulletins in one place!%0D%0A%0D%0AThank you!%0D%0A%0D%0A`}
                            onClick={() => this.sendRequest(parish.link)}
                          >
                            Send Request
                          </a>
                        </div>
                      )} */}
                      {/* {parishLink && (
                        <div className="text-center my-4 py-4">
                          <Link
                            className="btn-link btn btn-md defaultfontsize"
                            to={parishLink}
                          >
                            {label}
                          </Link>
                        </div>
                      )} */}
                    </div>
                  )}
                </div>
                {bulletinlist.length > 3 && (
                  <ScrollToTop css="mb-4 btn-outline-primary" />
                )}
                {bulletinlist.length > 0 && (
                  <LinkButton type="link" link={parishLink} label={label} />
                )}
                {/* <div className="mt-5 pt-5">
                  <p className="text-muted">{this.state.browserid}</p>
                </div> */}
              </div>
            </main>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default withRouter(ViewAllBulletin);
